import * as React from "react";
import { PermissionEnum } from "../api/ApiPermissionEnum";
import Modal from "./modal";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalLegacyClient } from "../api/WebPortalTokenClient";

export interface AssignToUserInGroupModal {
    show: boolean;
    headerText: string;
    permission: PermissionEnum;
    onAssign: (userToAssign: string, userName: string) => void;
    onClose: () => void;
}

export const AssignToUserInGroupModal = (props: AssignToUserInGroupModal) => {
    const [isFetching, setIsFetching] = React.useState(false);
    const [users, setUsers] = React.useState([]);
    const [selectedUser, setSelectedUser] = React.useState<string>("");

    const { study } = useCurrentStudyConfigurationContext();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const fetchUsers = async () => {
            const retrievedUsers = await legacyClient.getUsersByPermission(study.id, props.permission);
            setUsers(retrievedUsers);
        }

        fetchUsers();
    }, []);

    return (
        <Modal show={props.show} closeModalHandler={() => props.onClose()} header={props.headerText}>
            <div className="modal-body">
                <select className="form-control" value={selectedUser} onChange={e => setSelectedUser(e.target.value)}>
                    <option></option>
                    {users.map(i =>
                        <option key={i.Id} value={i.Id}>{i.Email}</option>
                    )}
                </select>
            </div>
            <div className="modal-footer">
                <button
                    disabled={isFetching || selectedUser === null}
                    className="btn btn-primary"
                    data-automationid="assign-to-user"
                    onClick={() => props.onAssign(selectedUser, users.find(u=> u.Id === selectedUser).Email)}
                >
                    Assign
                </button>
                <button className="btn btn-outline btn-primary" onClick={() => props.onClose()}>
                    Close
                </button>
            </div>
        </Modal>
    );
};
